import { Expose } from 'class-transformer';
import { Point } from 'geojson';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnLayerHitAttributes extends SnModel {
  @Expose()
  public address: string;

  @Expose()
  public arrivalTime: number;

  @Expose()
  public assignedUnit: string;

  @Expose()
  public callType: string;

  @Expose()
  public closedTime: number;

  @Expose()
  public dispatchTime: number;

  @Expose()
  public id: string;

  @Expose()
  public priority: number;

  @Expose()
  public receivedTime: number;
}

export class SnLayerHit extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  @ExposeRawData()
  public geometry: Point;

  @Expose()
  public attributes: any;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public timestamp: string;

  @Expose()
  public layer?: string;

  @Expose()
  public layerName?: string;

  @Expose()
  public organization?: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
